import { lisaUserData } from '../../modules/Lisa'
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import {VueRecaptcha} from "vue-recaptcha";

const FilePond = vueFilePond.default(FilePondPluginFileValidateType,FilePondPluginFileValidateSize);

export default {
    delimiters: ['{(', ')}'],
    components: {
        FilePond: FilePond,
        VueRecaptcha: VueRecaptcha
    },
    data() {
        return {
            lisaUserData,
            endpoints: {
                'goal': '/api/'
            },
            loading: false,
            errors: []
        }
    },
    mounted() {
        this.submit();
    },
    methods: {
        onCaptchaVerified: function (response) {
            lisaUserData['g-recaptcha-response'] = response;
            this.sendData()
            this.$refs.recaptcha.reset();
        },

        onCaptchaError: function () {
            console.error('An error occured');
            this.loading = false
            this.$refs.recaptcha.reset();
        },

        onCaptchaExpired: function () {
            console.error('Captcha expired');
            this.loading = false
            this.$refs.recaptcha.reset();
        },
        submit() {
            this.formAction = this.getEndpoint(this.lisaUserData.goal);
            this.loading = true;
            this.$refs.recaptcha.execute();
        },

        getEndpoint(slug) {
            switch (slug) {
                case 'rfp':
                    return '/api/rfp-enquiries'
                case 'job':
                    return '/api/job-enquiries'
                case 'quickwork':
                default:
                    return '/api/general-enquiries'
            }
        },

        sendData() {
            this.errors = [];

            fetch(this.formAction, {
                body: JSON.stringify(lisaUserData),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                return response.json()
            }).then(response => {
                // Failure.
                if (!response.success) {
                    if(Array.isArray(response)) {
                        for(let error of response) {
                            this.errors.push(error?.message)
                        }
                    } else {
                        this.errors.push(response?.message)
                    }
                    this.$refs.recaptcha?.reset();

                    for(let error of this.errors) {
                        gtag?.("event", "flow_submit_error", {
                            flow: lisaUserData.goal,
                            error: error
                        });
                    }

                    this.$emit('error', this.errors);
                } else {
                    this.$refs.recaptcha?.reset();
                    if(window.gtag) {
                        gtag?.("event", "flow_submit", {
                            flow: lisaUserData.goal
                        });
                    }
                    this.$emit('success');
                }

            }).catch((err) => {

                gtag?.("event", "flow_submit_error", {
                    flow: lisaUserData.goal,
                    error: err
                });

                // Shrug
                this.$emit('error', [err]);
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
